import $ from 'jquery';
import {tns} from "tiny-slider/src/tiny-slider";

export function initialize(context) {
    // Handle clicks on checker fields and rotate the state of the checker field
    $('.tiny-slider', context || document).each(function (i, el) {
        const $this = $(this);
        const options = {
            container: el,
            items: parseInt($this.attr('data-items'), 10) || 1,
            autoplay: $this.attr('data-autoplay') || false,
            slideBy: $this.attr('data-slide-by') || 1,
            mode: $this.attr('data-mode') || 'carousel',
            axis: $this.attr('data-axis') || 'horizontal',
            gutter: parseInt($this.attr('data-gutter'), 10) || 0,
            edgePadding: parseInt($this.attr('data-edge-padding'), 10) || 0,
            fixedWidth: parseInt($this.attr('data-fixed-width'), 10) || false,
            autoWidth: $this.attr('data-auto-width') || false,
            viewportMax: parseInt($this.attr('data-viewport-max'), 10) || false,
            center: $this.attr('data-center') || false,
            controls: $this.attr('data-controls') || false,
            controlsPosition: $this.attr('data-controls-position') || 'top',
            controlsText: JSON.parse($this.attr('data-controls-text') || 'false'),
            controlsContainer: $this.attr('data-controls-container') || false,
            prevButton: $this.attr('data-prev-button') || false,
            nextButton: $this.attr('data-next-button') || false,
            nav: el.hasAttribute('data-nav') ? $this.attr('data-nav') : true,
            navContainer: $this.attr('data-nav-container') || false,
            navAsThumbnails: $this.attr('data-nav-as-thumbnails') || false,
            arrowKeys: $this.attr('data-arrow-keys') || false,
            speed: parseInt($this.attr('data-speed'), 10) || 300,
            autoplayPosition: $this.attr('data-autoplay-position') || 'top',
            autoplayTimeout: parseInt($this.attr('data-autoplay-timeout'), 10) || 5000,
            autoplayDirection: $this.attr('data-autoplay-position') || 'forward',
            autoplayText: JSON.parse($this.attr('data-autoplay-text') || 'false'),
            autoplayHoverPause: $this.attr('data-autoplay-hover-pause') || false,
            autoplayButton: $this.attr('data-autoplay-button') || false,
            autoplayButtonOutput: $this.attr('data-autoplay-button-output') || false,
            autoplayResetOnVisibility: el.hasAttribute('data-autoplay-reset-on-visibility') ? $this.attr('data-autoplay-reset-on-visibility') : true,
            animateIn: $this.attr('data-animate-in') || 'tns-fadeIn',
            animateOut: $this.attr('data-animate-out') || 'tns-fadeOut',
            animateNormal: $this.attr('data-animate-normal') || 'tns-normal',
            animateDelay: parseInt($this.attr('data-animate-delay'), 10) || false,
            loop: el.hasAttribute('data-loop') ? $this.attr('data-loop') : true,
            rewind: el.hasAttribute('data-rewind') ? $this.attr('data-rewind') : true,
            autoHeight: el.hasAttribute('data-auto-height') ? $this.attr('data-auto-height') : true,
            responsive: JSON.parse($this.attr('data-responsive') || 'false'),
            lazyload: $this.attr('data-lazyload') || false,
            lazyloadSelector: $this.attr('data-lazyload-selector') || '.tns-lazy-img',
            touch: el.hasAttribute('data-touch') ? $this.attr('data-touch') : true,
            mouseDrag: $this.attr('data-mouse-drag') || false,
            swipeAngle: parseInt($this.attr('data-swipe-angle'), 10) || 15,
            preventActionWhenRunning: $this.attr('data-prevent-action-when-running') || false,
            preventScrollOnTouch : $this.attr('data-prevent-scroll-on-touch') || false,
            nested : $this.attr('data-nested') || false,
            freezable : el.hasAttribute('data-freezable') ? $this.attr('data-freezable') : true,
            disable : $this.attr('data-disable') || false,
            startIndex: parseInt($this.attr('data-start-index'), 10) || 0,
            onInit : $this.attr('data-on-init') || false,
            useLocalStorage : el.hasAttribute('data-use-local-storage') ? $this.attr('data-use-local-storage') : true,
            nonce : $this.attr('data-nonce') || false
        };
        var slider = tns(options);
        el.slider = slider;

        if (options.controls && options.controlsContainer){
            $(options.controlsContainer).find('.btn-prev, .btn-next').on('click', function (e) {
                e.preventDefault();
            });
            if (options.edgePadding) {
                $(options.controlsContainer).css('padding-right', (options.edgePadding) + 'px');
            }
        }
    });
}

export default {initialize};